import { Locales } from 'src/i18n'
import CustomerJson from './interfaces/CustomerJson'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default class Customer {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  language: Locales
  marketingConsent: boolean

  constructor(
    email: string,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    language: Locales,
    marketingConsent = false,
  ) {
    this.email = email
    this.firstName = firstName
    this.lastName = lastName
    this.phoneNumber = phoneNumber
    this.language = language
    this.marketingConsent = marketingConsent
  }

  get phoneNumberObj() {
    return parsePhoneNumberFromString(this.phoneNumber)
  }

  clone() {
    return new Customer(
      this.email,
      this.firstName,
      this.lastName,
      this.phoneNumber,
      this.language,
      this.marketingConsent,
    )
  }

  toJson() {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      language: this.language,
    }
  }

  static fromJson(data: CustomerJson) {
    return new this(
      data.email,
      data.firstName,
      data.lastName,
      data.phoneNumber,
      data.language,
      data.marketingConsent,
    )
  }
}
